// src/pages/Leader/hooks/useOrgChart.ts
import { useQuery } from '@tanstack/react-query'; //-tech-debt-react-query;
import { fetchItems } from '../support/queries';
import { computeSubtreeScope, OrgChartRow, OrgScope } from '../support/orgScope';
import { useMemo } from 'react';

export function useOrgChart(options?: any) {
  return useQuery({
    queryKey: ['OrgChart'],
    queryFn: async () => {
      // endpoint in your app: GET /api/db/user/org-chart
      // front-end fetchItems expects path without /api prefix depending on your env;
      // match how you call other db endpoints:
      return fetchItems('db/user/org-chart', {}, { includePageSize: false });
    },
    ...{
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        ...(options || {}),
        select: (rows: any) => (Array.isArray(rows) ? rows : []),
      },
  });
}

export function useLeaderScope(rows: OrgChartRow[], rootEmail: string | null | undefined): OrgScope {
  return useMemo(() => {
    if (!rootEmail) {
      return { rootEmail: '', rootUserId: null, emails: [], userIds: [], managers: [] };
    }
    return computeSubtreeScope(rows, rootEmail);
  }, [rows, rootEmail]);
}